import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const IndpendentPageIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 264 126">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h264v125.832H0z" />
      <circle opacity={0.4} cx={34.093} cy={27.458} fill="#2962FF" fillOpacity={0.3} r={19.122} />
      <rect
        opacity={0.4}
        x={61}
        y={31.542}
        width={50.579}
        height={9.869}
        rx={4.935}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <path fill="#000" fillOpacity={0.12} d="M16.038 58.149h234.393v1H16.038z" />
      <rect
        opacity={0.4}
        x={14.804}
        y={71.72}
        width={83.888}
        height={9.869}
        rx={4.935}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={15.001}
        y={89}
        width={96}
        height={10}
        rx={5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={15.001}
        y={106}
        width={61}
        height={10}
        rx={5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={61}
        y={13}
        width={67}
        height={11}
        rx={5.5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
    </svg>
  </SvgIcon>
);

export default IndpendentPageIcon;
